import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BuilderRequest } from 'src/app/models/requests';
import {CdkDragDrop} from '@angular/cdk/drag-drop';
import { WorkflowStep1Placeholder } from 'src/app/models/workflow';
import { DocumentModel, PageSize } from 'src/app/models/document.model';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { EditDocumentModalComponent } from '../edit-document-modal/edit-document-modal.component';
import { Is_NON_Download_Action } from 'src/app/constants/actor-action.enum';

@Component({
  selector: 'app-documentlist',
  templateUrl: './documentlist.component.html'
})
export class DocumentListComponent {
  @Input() SortingAllowed: boolean = true;
  @Input() Request!: BuilderRequest;
  @Input() placeholders: WorkflowStep1Placeholder[] | undefined  = [];
  @Input() workflowId?: string;
  @Input() SupportedDocumentTypes?: string[];
  @Input() allowAddDocuments?: boolean = false;
  @Input() showDocument?: boolean = true;
  @Output() DocumentChange = new EventEmitter();
  @Output() DocumentDeleted = new EventEmitter<string>();
  @Output() PlaceholderDeleted = new EventEmitter<number>();
  @Output() DocumentChangeOrder = new EventEmitter();
  @Output() OnFileSelectedWorkflow = new EventEmitter();
  @Output() getRequest: EventEmitter<string> = new EventEmitter<string>();
  @Output() openViewer: EventEmitter<any> = new EventEmitter<any>();
  @Output() UploadCloudDocuments = new EventEmitter();
  @Output() loadThumbnail = new EventEmitter();
  disabled: number = -1;
  requestId: string = this.route.snapshot.paramMap.get('requestId') ?? "";
  draggingDisabled: boolean = true;
  indexChangeOrder: number = 0;
  
  constructor(private route: ActivatedRoute, private modalService: NgbModal) {
    // Must not be empty. It's approved by a comment.
  }

  documentDropped(event: CdkDragDrop<string[]>) {
    this.draggingDisabled = true;
    this.DocumentChangeOrder.emit(event);
  }
  
  documentChange(event:any){
    this.DocumentChange.emit(event);
  }
  
  documentDeleted(documentId:string){
    this.DocumentDeleted.emit(documentId);
  }

  placeholderDeleted(placeholderId:number){
    this.PlaceholderDeleted.emit(placeholderId);
  }

  EnableDocumentChangeOrder(event: any) {
    this.indexChangeOrder = event.position - 1;
    this.draggingDisabled = false;
  }
  
  checkForActionsOnDocument(documentId:string){
    return (this.Request.actors.findIndex(p => p.documentId == documentId && Is_NON_Download_Action(p.action)) > -1 );
  }

  onFileSelectedWorkflow(event: any) {
    this.OnFileSelectedWorkflow.emit(event);
  }

  GetRequest(event:any) {
    this.getRequest.emit(event);
  }
  
  getDossierDocumentByPlaceholder(placeholderId: number) {
    return this.Request?.documentInfo?.find(p => p.workflowPlaceholderId === placeholderId);
  }
  getDossierDocumentsByPlaceholder(placeholderId: number) {
    return this.Request?.documentInfo?.filter(p => p.workflowPlaceholderId === placeholderId);
  }

  documentHasPlaceholder(document: any): boolean {
    return (this.placeholders && this.placeholders?.findIndex(p => p.placeholderId == document.workflowPlaceholderId) >= 0) ?? false;
  }

  getDocumentsWithoutPlaceholder(): DocumentModel[] {
    return this.Request.documentInfo.filter(document => !this.documentHasPlaceholder(document));
  }

  areAnyPlaceholdersWithoutDocument(): boolean {
    return this.placeholders != undefined && this.placeholders.length > 0 && (this.placeholdersWithoutDocument().length > 0);
  }

  placeholdersWithoutDocument(): WorkflowStep1Placeholder[] {
    return this.placeholders ? this.placeholders.filter(p => this.getDossierDocumentByPlaceholder(p.placeholderId) == undefined) : [];
  }

  openPreview(event: any) {
    this.openViewer.emit(event);
  }

  getIndexOfDocument(event: string): number {
    let docIndex: number = this.Request?.documentInfo?.sort((n1: any, n2: any) => n1.workflowPlaceholderId! - n2.workflowPlaceholderId!).findIndex(s => s.id == event);
    return docIndex;
  }

  editDocument(event: any) {
    let ngbModalOptions: NgbModalOptions = {
      backdrop : 'static',
      keyboard : false,
      centered: true,
      size: 'editdocument'
    };
    let pageSizes: PageSize[] = [];
    JSON.parse(event.document.pageSizes).forEach((pageSize: PageSize) => {
      let pageSizeDefault: PageSize = new PageSize();
      pageSizeDefault.X = pageSize.X;
      pageSizeDefault.Y = pageSize.Y;
      pageSizes.push(pageSizeDefault);
    });
    const documentModalRef = this.modalService.open(EditDocumentModalComponent, ngbModalOptions);
    documentModalRef.componentInstance.document = event.document;
    documentModalRef.componentInstance.pageSizes = pageSizes;
    documentModalRef.componentInstance.request = this.Request;
    documentModalRef.componentInstance.loadThumbnail.subscribe((pageId:number) => {
      this.loadThumbnail.emit({document: event, pageId: pageId, ifNotExists: true});
    });
    documentModalRef.componentInstance.forceLoadThumbnail.subscribe((pageId:number) => {
      this.loadThumbnail.emit({document: event, pageId: pageId, ifNotExists: false});
    });
    documentModalRef.componentInstance.getRequest.subscribe(() => {
      this.getRequest.emit();
    });
  }
}
